import React, { Component } from "react";
import logo from "../../assets/img/logoHeader.svg";
import "./header.css";
import {Container} from "react-bootstrap";

class Header extends Component {
  constructor() {
    super();
    this.state = {
      openMenu: false,
      userRestricId: localStorage.getItem("userRestricId") || 0
    }
  }
  openMenu() {
    this.setState({openMenu: !this.state.openMenu})
  }
  render() {
    return (
      <header>
        <nav>
          <Container style={{padding: '0px'}}>
            <div className="nav">
              <div className="logo">
                <a href="https://fullmusculo.com/">
                  <img width={689} height={175} href="https://fullmusculo.com/" src={logo} alt=""></img>
                </a>
              </div>
              <div className={"open-menu"} onClick={()=>this.openMenu()}>
                <i className={`fas ${!this.state.openMenu ? 'fa-bars':'fa-times'}`}></i>
              </div>
              <div className={`main-menu ${this.state.openMenu ? 'open':'closeMenu'} `} style={{justifyContent:this.state.userRestricId == 0?'space-evenly':'flex-end'}}>
                <ul>
                  <li>
                    <a href="https://fullmusculo.com/blog/">Blog</a>
                  </li>
                  <li>
                    <a href="https://fullmusculo.com/podcast-fitness/">Podcast</a>
                  </li>
                  <li className={"dropdownmenu"}><a>Recursos <i className={"fas fa-chevron-down"}></i></a>
                    <div className={"dropdownmenu__menu"}>
                      <ul>
                        <li><a href="https://fullmusculo.com/calculadora-de-calorias">Dietas</a></li>
                        <li><a href="https://fullmusculo.com/suplementos-deportivos">Suplementos</a></li>
                        <li><a href="https://fullmusculo.com/ejercicios">Ejercicios</a></li>
                      </ul>
                    </div>
                  </li>
                  <li><a href="https://fullmusculo.com/academy">Academia</a></li>
                  {this.state.userRestricId != 0 ?<li>
                    <a href="https://fullmusculo.com/user/">Tu perfil</a>
                  </li>:null}

                </ul>
                {this.state.userRestricId == 0 ? <ul>
                  <li>
                    <a className={"btn-primary"} href="https://fullmusculo.com/fullmusculo-plus/">Subscribete</a>
                  </li>
                  <li>
                    <a href="https://fullmusculo.com/account/">Login</a>
                  </li>
                </ul>:null}
                </div>
              </div>

          </Container>
        </nav>
      </header>
    );
  }
}

export default Header;
